import React, { Component } from 'react';
import { Button, Card, Col, Form, InputNumber, message, Row, Select } from 'antd';
import { browserHistory } from 'react-router';
import { goBack } from '@comm/BackBtn';
import { queryDepartmentProtection, querySaveDepartmentProtection } from '@api/crm/crm';

import './PagesetProtect.less';

const { Option } = Select;
const protect = {
  termSelfNoRegistered: '自己挖掘的非注册客户保护期',
  termSelfRegistered: '自己挖掘的注册客户保护期',
  termPool: '开放客户池的保护期',
  maxTerm: '最大保护期限制',
};

const FormItem = Form.Item;

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      termAmount: [{ term: {}, key: 0 }],
      termSelfNoRegistered: {},
      termSelfRegistered: {},
      termPool: {},
      maxTerm: {},
    };
  }

  componentDidMount() {
    this.uuid = this.props.params.uuid;
    this.getData();
  }

  formatParams = (key, values) => {
    return {
      unit: values[`${key}-unit`],
      term: values[`${key}-term`],
    };
  };

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const config = {};
        config.termSelfNoRegistered = this.formatParams('termSelfNoRegistered', values);
        config.termSelfRegistered = this.formatParams('termSelfRegistered', values);
        config.maxTerm = this.formatParams('maxTerm', values);
        config.termPool = this.formatParams('termPool', values);
        config.limitPool = values.limitPool;
        config.limitSelf = values.limitSelf;
        config.termAmount = this.state.termAmount;
        const params = {
          uuid: this.uuid,
          config,
        };
        this.handleSave(params);
      }
    });
  };

  handleSave = params => {
    querySaveDepartmentProtection(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        browserHistory.go(-1);
      } else {
        message.error(res.message);
      }
    });
  };

  getData = () => {
    queryDepartmentProtection({
      uuid: this.uuid,
    }).then(res => {
      if (res.statusCode === 200 && res.data) {
        res.data.termAmount.map((item, index) => {
          item.key = index;
          return item;
        });
        this.setState({
          termAmount: res.data.termAmount,
          termSelfNoRegistered: res.data.termSelfNoRegistered,
          termSelfRegistered: res.data.termSelfRegistered,
          termPool: res.data.termPool,
          maxTerm: res.data.maxTerm,
          limitPool: res.data.limitPool,
          limitSelf: res.data.limitSelf,
        });
      } else if (res.statusCode !== 200) {
        message.error(res.message);
      }
    });
  };

  addAmount = () => {
    const { termAmount } = this.state;
    const key = termAmount[termAmount.length - 1].key + 1;
    this.setState({
      termAmount: [...termAmount, { term: {}, key }],
    });
  };

  subAmount = key => {
    const { termAmount } = this.state;
    const termAmountArr = termAmount.filter(item => {
      return item.key !== key;
    });
    this.setState({
      termAmount: termAmountArr,
    });
  };

  handleChange = (index, key1, key2) => {
    return e => {
      const { termAmount } = this.state;
      if (key2) {
        termAmount[index][key1][key2] = e;
      } else {
        termAmount[index][key1] = e;
      }
      this.setState({
        termAmount,
      });
    };
  };

  renderFormItem = key => {
    const { form } = this.props;
    const configItem = this.state[key];
    return (
      <Row>
        <FormItem label={protect[key]}>
          {form.getFieldDecorator(`${key}-term`, {
            rules: [{ required: true, message: '请输入 !' }],
            initialValue: configItem.term,
          })(<InputNumber />)}
        </FormItem>
        <FormItem>
          {form.getFieldDecorator(`${key}-unit`, {
            rules: [{ required: true, message: '请输入 !' }],
            initialValue: configItem.unit ? `${configItem.unit}` : '5',
          })(
            <Select style={{ width: '80px' }}>
              <Option key="1">年</Option>
              <Option key="2">月</Option>
              <Option key="5">日</Option>
            </Select>,
          )}
        </FormItem>
      </Row>
    );
  };

  renderTermAmount = () => {
    const { form } = this.props;
    const { getFieldDecorator } = form;
    const { termAmount } = this.state;
    return termAmount.map((item, index) => {
      return (
        <Row key={item.key}>
          <FormItem label="消费金额保护期">
            {getFieldDecorator(`amount${item.key}`, {
              rules: [{ required: true, message: '请填写消费金额!' }],
              initialValue: item.amount,
            })(<InputNumber onChange={this.handleChange(index, 'amount')} />)}
            元
          </FormItem>
          <FormItem>
            {getFieldDecorator(`term${item.key}`, {
              rules: [{ required: true, message: '请填写保护时长!' }],
              initialValue: item.term.term,
            })(<InputNumber onChange={this.handleChange(index, 'term', 'term')} />)}
          </FormItem>
          <FormItem>
            {getFieldDecorator(`unit${item.key}`, {
              rules: [{ required: true, message: '请选择时间单位!' }],
              initialValue: item.term.unit ? `${item.term.unit}` : '5',
            })(
              <Select style={{ width: '80px' }} onChange={this.handleChange(index, 'term', 'unit')}>
                <Option key="1">年</Option>
                <Option key="2">月</Option>
                <Option key="5">日</Option>
              </Select>,
            )}
          </FormItem>
          <FormItem>
            {index === termAmount.length - 1 ? (
              <Button type="primary" style={{ marginRight: '10px' }} onClick={this.addAmount}>
                +
              </Button>
            ) : null}
            {termAmount.length === 1 ? null : (
              <Button onClick={() => this.subAmount(item.key)}>-</Button>
            )}
          </FormItem>
        </Row>
      );
    });
  };

  render() {
    const { form } = this.props;
    const { limitPool, limitSelf } = this.state;

    return (
      <Card title="设置客户保护限制">
        <Form onSubmit={this.handleSubmit} className="set-protect" layout="inline">
          <Card title="保护设置" bordered={false}>
            {this.renderFormItem('termSelfNoRegistered')}
            {this.renderFormItem('termSelfRegistered')}
            {this.renderFormItem('termPool')}
            {this.renderTermAmount()}
          </Card>
          <Card title="保护数设置" bordered={false}>
            <Row>
              <FormItem label="开放客户保护数">
                {form.getFieldDecorator('limitPool', {
                  rules: [{ required: true, message: '请输入 !' }],
                  initialValue: limitPool,
                })(<InputNumber />)}
              </FormItem>
              <p className="unit">个</p>
            </Row>
            <Row>
              <FormItem label="自己挖掘保护数">
                {form.getFieldDecorator('limitSelf', {
                  rules: [{ required: true, message: '请输入 !' }],
                  initialValue: limitSelf,
                })(<InputNumber />)}
              </FormItem>
              <p className="unit">个</p>
            </Row>
            {this.renderFormItem('maxTerm')}
          </Card>
          <Row>
            <Col span={24} style={{ marginBottom: 15, textAlign: 'right' }}>
              <Button style={{ marginRight: 10 }} type="primary" htmlType="submit">
                确定
              </Button>
              <Button onClick={goBack}>取消</Button>
            </Col>
          </Row>
        </Form>
      </Card>
    );
  }
}

export default Form.create({ wrappedComponentRef: true })(Index);



// WEBPACK FOOTER //
// ./src/components/crm/department/PageSetProtect.js